import { Button, Form, Input, Col, Row, message, Select } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import moment from "moment";
import { LoginRequest, loginWithSession } from "../../api/auth";
import { storeLoginResponse } from "../../utils/main-utils";
import { useTranslation } from "react-i18next";

import {
  getCurrencyById,
  getSecondaryCurrencyById,
  getSettingsById,
} from "../../api/setting";
import { useEffect, useState } from "react";
import { useLanguage } from "../ContextAPI/LanguageContext";
export default function NewLogin() {
  const getCurrMutation = useMutation("getCurr", getCurrencyById, {
    onSuccess: (res) => {
      localStorage.setItem("mainCurrency", JSON.stringify(res.data));
    },
  });
  const getSecondaryCurrMutation = useMutation(
    "getSecondaryCurr",
    getSecondaryCurrencyById,
    {
      onSuccess: (res) => {
        localStorage.setItem("secondaryCurrency", JSON.stringify(res.data));
      },
    }
  );

  const [, setError] = useState("");
  const getSettingMutation = useMutation("getSettings", getSettingsById, {
    onSuccess: (res: any) => {
      localStorage.setItem(
        "companyPrimaryNumber",
        res.data.receiptHeaderPhoneNumber
      );
      localStorage.setItem(
        "receiptHeaderCompanyName",
        res.data.receiptHeaderCompanyName
      );
      localStorage.setItem(
        "receiptHeaderLocation",
        res.data.receiptHeaderlocation
      );
      localStorage.setItem(
        "receiptHeaderVATNumber",
        res.data.receiptHeaderVATNumber
      );
      localStorage.setItem(
        "receiptHeaderMOFNumber",
        res.data.receiptHeaderMOFNumber
      );
      localStorage.setItem("taxRate", JSON.stringify(res.data));
    },
  });
  const navigate = useNavigate();
  const LoginMutation = useMutation(loginWithSession, {
    onSuccess: (data) => {
      storeLoginResponse(data?.data);
      localStorage.setItem("selectedKey", "5");
      localStorage.setItem("sessionId", data?.data?.session?.id);
      localStorage.setItem("tillId", data?.data?.till?.id);
      Promise.all([
        getCurrMutation.mutate(),
        getSettingMutation.mutate(),
        getSecondaryCurrMutation.mutate(),
      ]).then(() => {
        if (data?.data?.session?.isNew)
          navigate(`/till/${data?.data?.till?.id}`, {
            replace: true,
            state: { isEdit: false },
          });
        else navigate("/main", { replace: true });
      });
    },
    onError: (error: any, context: unknown) => {
      if (setError) {
        setError(error.response.data.message);
        message.error(error.response.data.message);
      } else {
        message.error("");
      }
    },
  });
  const currentDate = new Date();
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  const onFinish = (values: LoginRequest) => {
    const credentials: LoginRequest = {
      userName: values.userName,
      password: values.password,
      workstationId: 1,
      date: formattedDate,
    };
    LoginMutation.mutate(credentials);
  };

  const [capsLockOn, setCapsLockOn] = useState(false);

  // const handleKeyPress = (e: any) => {
  //   const isCapsLockOn = e.getModifierState("CapsLock");
  //   setCapsLockOn(isCapsLockOn);
  // };
  // useEffect(() => {
  //   // Add event listener when component mounts
  //   window.addEventListener("keydown", handleKeyPress);

  //   // Clean up event listener when component unmounts
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyPress);
  //   };
  // }, []);

  const [t, i18n] = useTranslation("common");
  const dir = i18n.dir();
  const { Option } = Select;
  const { lang, setLang } = useLanguage();

  const updateDirection = (language: string | null) => {
    const body = document.body;
    if (body) {
      body.dir = language === 'ar' ? 'rtl' : 'ltr';
    }
  };

  const handleLanguageChange = (value: string) => {
    setLang(value)
    localStorage.setItem('language', value);
  }


  useEffect(() => {
    if (!lang) {
      localStorage.setItem('language', 'en');
      setLang('en');
      return;
    }
    localStorage.setItem('language', lang);
    i18n.changeLanguage(lang);
    updateDirection(lang);
    setLang(lang);
  }, [lang, i18n]);


  return (
    <>
      <div
        style={{
          background:
            "radial-gradient(circle at center, #0048C5 0%, #1677FF 53.52%, #0048C5 80.75%)",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Row
          style={{
            alignItems: "center",
            background: "white",
            width: "1000px",
            height: "550px",
            borderRadius: "3px",
          }}
        >
          <Col offset={1} span={11}>
            <center>
              <h1
                style={{
                  color: "#0048C5",
                  padding: "25px",
                }}
              >
                {t('welcome-to')}
              </h1>
              <img src={require("../../images/posmodified3.png")} alt="" />
            </center>
          </Col>

          <Col span={11}>
            <>
              <div
                style={{
                  background: "white",
                  marginTop: "35px",
                  padding: "40px",
                  borderRadius: "1px",
                  border: "2px solid #0048C5",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Form
                  style={{ width: "100%" }}
                  name="basic"
                  layout="vertical"
                  onFinish={onFinish}
                  autoComplete="on"
                >
                  <center>
                    <h1
                      style={{
                        color: "#0048C5",
                        marginBottom: "40PX",
                        fontSize: "35px",
                      }}
                    >
                      {t('login').toUpperCase()}
                    </h1>
                  </center>
                  <Form.Item
                    name="userName"
                    rules={[
                      {
                        required: true,
                        message: `${t("missing-username")}`,
                      },
                    ]}
                  >
                    <Input
                      style={{
                        width: "100%",
                        height: "50px",
                        border: "0.5px solid #0048C5",
                        borderRadius: "3px",
                      }}
                      prefix={
                        <UserOutlined
                          style={{ fontSize: "17px", color: "#0E4375" }}
                        />
                      }
                      placeholder={`${t("enter-username")}`}
                      className="login-input"
                      autoComplete="off"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: `${t("missing-password")}`,
                      },
                    ]}
                  >
                    <Input.Password
                      autoComplete="off"
                      style={{
                        width: "100%",
                        height: "50px",
                        border: "0.5px solid #0048C5",
                        borderRadius: "3px",
                      }}
                      prefix={
                        <LockOutlined
                          style={{ fontSize: "17px", color: "#0E4375" }}
                        />
                      }
                      placeholder={`${t("enter-password")}`}
                      className="login-input"
                    // onKeyDown={handleKeyPress}
                    />
                  </Form.Item>
                  <Col offset={0} span={8}>
                    <div>
                      <Select
                        defaultValue={localStorage.getItem('language') || 'en'}
                        style={{ width: 120 }}
                        onChange={handleLanguageChange}
                      >
                        <Option value="en">English</Option>
                        <Option value="ar">العربية</Option>
                      </Select>
                    </div>
                  </Col>
                  {capsLockOn ? (
                    <div
                      style={{
                        color: "red",
                        marginTop: "5px",
                      }}
                    >
                      {t("caps-lock-is-on")}
                    </div>
                  ) : (
                    <div
                      style={{
                        color: "#0048C5",
                        marginTop: "5px",
                        visibility: "hidden",
                      }}
                    >
                      {t("caps-lock-is-off")}
                    </div>
                  )}
                  <Form.Item>
                    <Button
                      style={{
                        backgroundColor: "#0048C5",
                        borderRadius: "3px",
                        marginTop: "10%",
                        width: "100%",
                        height: "50px",
                        fontSize: "20px",
                      }}
                      type="primary"
                      htmlType="submit"
                    >
                      {LoginMutation.isLoading ? `${t("loading") + "..."}` : t("login").toUpperCase()}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </>
          </Col>
          {localStorage.getItem('language') === 'ar' ? (
            <Row justify="center">
              <Col>
                <p style={{ marginLeft: '0.3em' }}>©</p>
              </Col>
              <Col>
                <p style={{ marginLeft: '0.3em' }}>جميع الحقوق محفوظة</p>
              </Col>
              <Col>
                <p style={{ marginLeft: '0.3em' }}>Data Solutions and Digital Services</p>
              </Col>
              <Col>
                <p style={{ marginLeft: '0.3em' }}>{moment().year()}</p>
              </Col>
            </Row>
          ) : (
            <Row justify="center">
              <Col>
                <p>© All rights reserved Data Solutions and Digital
                  Services {moment().format("YYYY")}</p>
              </Col>
            </Row>
          )}

        </Row>
      </div >
    </>
  );
}
